// src/services/branchService.js

export const fetchContacts = async () => {
  try {
    const response = await fetch("/api/contacts");
    if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("Ошибка загрузки контактов:", error);
    return [];
  }
};

export const fetchReviews = async () => {
  try {
    const response = await fetch("/api/reviews");
    if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("Ошибка загрузки отзывов:", error);
    return [];
  }
};

export const fetchGallery = async () => {
  try {
    const response = await fetch("/api/photos");
    if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("Ошибка загрузки отзывов:", error);
    return [];
  }
};

export const fetchAdvantages = async () => {
  try {
    const response = await fetch("/api/advantages");
    if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("Ошибка загрузки преимуществ:", error);
    return [];
  }
};

export const fetchGroups = async () => {
  try {
    const response = await fetch("/api/groups_with_branch");
    if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("Ошибка загрузки преимуществ:", error);
    return [];
  }
};

export const fetchBranches = async () => {
  try {
    const response = await fetch("/api/branches");
    if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
    const data = await response.json();

    return Array.isArray(data)
      ? data.map((item) => ({
          id: item.id,
          name: item.name || "",
        }))
      : [];
  } catch (error) {
    console.error("Ошибка загрузки филиалов:", error);
    return [];
  }
};

export const fetchPhones = async () => {
  try {
    const response = await fetch("/api/phones");
    if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
    const data = await response.json();

    return data.map((item) => ({
      phone_number: item.phone_number,
      display_order: item.display_order || 0,
    }));
  } catch (error) {
    console.error("Ошибка загрузки телефонов:", error);
    throw error;
  }
};

export const fetchCategories = async () => {
  try {
    const response = await fetch("/api/categories");
    if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
    const data = await response.json();

    return Array.isArray(data)
      ? data.map((item) => ({
          id: item.id,
          name: item.name || "",
          price: item.price || "",
          features: item.features || [],
          display_order: item.display_order || 0,
        }))
      : [];
  } catch (error) {
    console.error("Ошибка загрузки категорий:", error);
    return [];
  }
};

export const fetchAdditionalLessons = async () => {
  try {
    const response = await fetch("/api/additional_lessons");
    if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
    const data = await response.json();

    return Array.isArray(data)
      ? data.map((item) => ({
          id: item.id,
          name: item.name || "",
          duration: item.duration || "",
          price: item.price || "",
          display_order: item.display_order || 0,
        }))
      : [];
  } catch (error) {
    console.error("Ошибка загрузки дополнительных занятий:", error);
    return [];
  }
};

export const fetchDocuments = async () => {
  try {
    const response = await fetch("/api/documents");
    if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
    const data = await response.json();

    return Array.isArray(data)
      ? data.map((item) => ({
          id: item.id,
          name: item.name || "",
          file_path: item.file_path || "",
          display_order: item.display_order || 0,
        }))
      : [];
  } catch (error) {
    console.error("Ошибка загрузки документов:", error);
    throw error;
  }
};

export const submitReview = async (reviewData) => {
  try {
    const response = await fetch("/api/reviews", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(reviewData),
    });

    if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("Ошибка отправки отзыва:", error);
    throw error;
  }
};

export const submitFeedback = async (feedbackData) => {
  try {
    const response = await fetch("/api/feedback", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(feedbackData),
    });

    if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("Ошибка отправки формы обратной связи:", error);
    throw error;
  }
};
